import { render, staticRenderFns } from "./AdmPayments.vue?vue&type=template&id=0dda52b5&scoped=true"
import script from "./AdmPayments.vue?vue&type=script&lang=js"
export * from "./AdmPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dda52b5",
  null
  
)

export default component.exports